import axios from 'axios';
import { createHeaders } from './headerUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AdminService = {
  getAllProfiles: async (page = 1, pageSize = 25, search = '', sortField = 'email', sortDirection = 'asc') => {
    try {
      const params = new URLSearchParams({
        page,
        pageSize,
        sortField,
        sortDirection
      });
      
      if (search) {
        params.append('search', search);
      }
      
      const apiUrl = `${BASE_URL}/admin/all/profiles?${params.toString()}`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): getAllProfiles ", error.message);
      throw error;
    }
  },
  getProfile: async (userId) => {
    try {
      const apiUrl = `${BASE_URL}/admin/${userId}`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      console.log("AdminService: getProfile response data:", response.data);
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): getProfile ", error.message);
      throw error;
    }
  },
  getPermissionGroups: async () => {
    try {
      const apiUrl = `${BASE_URL}/admin/groups`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): getPermissionGroups ", error.message);
      throw error;
    }
  },
  addProfile: async (newUserData) => {
    try {
      const apiUrl = `${BASE_URL}/admin/addUser`;
      const headers = createHeaders();
      const response = await axios.post(apiUrl, newUserData, { headers });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): addProfile ", error.message);
      throw error.response.data.msg;
    }
  },
  updateProfile: async (updatedProfileData) => {
    try {
      const apiUrl = `${BASE_URL}/admin/updateUser`;
      const headers = createHeaders();
      const response = await axios.put(apiUrl, updatedProfileData, { headers });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): updateProfile ", error.message);
      throw error;
    }
  },
  deleteProfile: async (userId) => {
    try {
      const apiUrl = `${BASE_URL}/admin/deleteUser`;
      const headers = createHeaders();
      // Send email in the request body for soft deletion
      const response = await axios.put(apiUrl, { email: userId }, { headers });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): deleteProfile ", error.message);
      throw error;
    }
  },
  hardDeleteProfile: async (userId) => {
    try {
      const apiUrl = `${BASE_URL}/admin/hardDeleteUser`;
      const headers = createHeaders();
      // Send DELETE request with email in request body for hard deletion
      const response = await axios.delete(apiUrl, { 
        headers, 
        data: { email: userId } 
      });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): hardDeleteProfile ", error.message);
      throw error;
    }
  },
  blockUser: async (userId, isBlocked) => {
    try {
      const apiUrl = `${BASE_URL}/admin/blockUser`;
      const headers = createHeaders();
      const body = { 
        email: userId, 
        blocked: isBlocked 
      };
      const response = await axios.put(apiUrl, body, { headers });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): blockUser ", error.message);
      throw error;
    }
  },
  exportUsers: async () => {
    try {
      const apiUrl = `${BASE_URL}/admin/export-users`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): exportUsers ", error.message);
      throw error;
    }
  },
  deleteUserProfileData: async (email, field, resetTimer) => {
    try {
      const apiUrl = `${BASE_URL}/admin/deleteUserProfileData`;
      const headers = createHeaders();
      const response = await axios.put(apiUrl, { email, field, resetTimer }, { headers });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): deleteUserProfileData ", error.message);
      throw error;
    }
  },
  resetBirthdayTimer: async (email) => {
    try {
      const apiUrl = `${BASE_URL}/admin/resetBirthdayTimer`;
      const headers = createHeaders();
      const response = await axios.put(apiUrl, { email }, { headers });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): resetBirthdayTimer ", error.message);
      throw error;
    }
  },
  getUserUsageTracking: async (email) => {
    try {
      const apiUrl = `${BASE_URL}/admin/usage-tracking/${encodeURIComponent(email)}`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response;
    } catch (error) {
      console.log("AdminService (ERROR): getUserUsageTracking ", error.message);
      throw error;
    }
  },
};

export default AdminService;
